import React from 'react';

interface AlertProps {
  type: 'success' | 'error' | 'info';
  children: React.ReactNode;
}

const Alert: React.FC<AlertProps> = ({ type, children }) => {
  const baseClasses = 'mt-4 rounded-lg p-3 text-sm';

  const typeClasses = {
    success: 'bg-emerald-500/20 border border-emerald-500/30 text-emerald-200',
    error: 'bg-red-500/20 border border-red-500/30 text-red-200',
    info: 'bg-blue-500/20 border border-blue-500/30 text-blue-200',
  };

  return (
    <div className={`${baseClasses} ${typeClasses[type]}`}>{children}</div>
  );
};

export default Alert;
